import React from "react"
import { assembleSrc } from "../icons/icon"

export function OutlookSupportedLink({ styles, properties }) {
  const iconSrc = assembleSrc(
    properties.icon,
    styles.iconColor,
    "#000000",
    "icon-only"
  )

  const trStyles = {
    padding: "1em",
    margin: "1em 0",
    borderStyle: "solid",
    borderRadius: styles.borderRadius,
    backgroundColor: styles.backgroundColor,
    borderWidth: styles.linkBorderWidth,
    borderColor: styles.linkBorderColor,
    fontWeight: styles.fontWeight
  }

  const iconStyles = {
    marginRight: "1em",
    borderStyle: "solid",
    borderWidth: styles.iconBorderWidth,
    borderColor: styles.iconBorderColor,
    borderRadius: styles.borderRadius
  }

  return (
    <>
      <tr style={trStyles}>
        {styles.useIcons && (
          <td width="40px">
            <img
              src={iconSrc}
              style={iconStyles}
              width="40"
              height="40"
              alt=""
            />
          </td>
        )}
        <td>
          <p style={{ padding: 0 }}>
            <a
              href={properties.url}
              target="_blank"
              rel="noopener noreferrer"
              className="ck-paragraph-font"
              style={{
                textDecoration: "none",
                color: styles.textColor,
                fontSize: styles.fontSize + "px",
                padding: styles.useIcons ? 0 : styles.fontSize
              }}
            >
              {properties.text}
            </a>
          </p>
        </td>
      </tr>
      <tr height="16" />
    </>
  )
}

export function Link({ styles, properties }) {
  const iconSrc = assembleSrc(
    properties.icon,
    styles.iconColor,
    "#000000",
    "icon-only"
  )

  const linkStyles = {
    display: "flex",
    alignItems: "center",
    padding: "1em",
    margin: "1em 0",
    textDecoration: "none",
    borderStyle: "solid",
    backgroundColor: styles.backgroundColor,
    borderWidth: styles.linkBorderWidth + "px",
    borderColor: styles.linkBorderColor,
    borderRadius: styles.borderRadius,
    color: styles.textColor
  }

  const iconStyles = {
    marginRight: "1em",
    borderStyle: "solid",
    borderWidth: styles.iconBorderWidth,
    borderColor: styles.iconBorderColor,
    borderRadius: styles.borderRadius,
    verticalAlign: "middle",
    width: "40px",
    height: "40px",
    maxWidth: "100%",
    marginTop: "auto",
    marginBottom: "auto"
  }

  return (
    <a
      style={linkStyles}
      href={properties.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {styles.useIcons && (
        <img src={iconSrc} style={iconStyles} width="40" height="40" alt="" />
      )}
      <span className="ck-paragraph-font" style={{ verticalAlign: "middle" }}>
        {properties.text}
      </span>
    </a>
  )
}
